import { Button, OutlinedInput, Typography } from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TrashIcon from "../../../assets/svgs/TrashIcon";
import LoadingApp from "../../../components/LoadingApp";
import ModalAction from "../../../components/ModalAction";
import ModalFeedBack from "../../../components/ModalFeedBack";
import { TicketRegistrationValidation } from "../../../interfaces/validation/TicketRegistrationValidation";
import {
  cadastrarBoletoDigital,
  cancelarBoletoDigital,
  getDadosCadastroBoletoDigital,
} from "../../../services/BoletoService";
import { getPermissaoCadastroBoleto } from "../../../services/PermissoesService";
import { cellphoneMask } from "../../../utils/PhoneRegex";
import "./styles.css";
import { sxButton, sxError, sxInput, sxLabel } from "./sxProps";
import useFocus from "../../../utils/hooks/useFocus";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import PageTitle from "../../../components/Accessibility/PageTitle";

function CadastrarBoleto() {
  const [tel, setTel] = useState<string>("");
  const [email1, setEmail1] = useState<string>("");
  const [email2, setEmail2] = useState<string>("");
  const [email3, setEmail3] = useState<string>("");
  const [id, setId] = useState<string>("");
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [modalAction, setModalAction] = useState<null | {
    handleShowModal?: () => void;
    textOutlinedButton: string;
    textContainedButton: string;
    title: string;
    subTitle?: string;
    handleOutlinedButton?: () => void;
    handleContainedButton?: () => void;
    icon: string;
  }>(null);
  const [modalFeedback, setmodalFeedback] = useState<null | {
    showButtonModal?: boolean;
    icon?: "error" | "success";
    title?: string;
    textButton?: string;
    subTitle?: string;
    action: () => void;
  }>(null);
  const [permission, setPermission] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>(
    "Esta funcionalidade não está disponível para o seu cartão."
  );

  const accessibility = useAccessibility();

  const navigate = useNavigate();
  useEffect(() => {
    const getTicket = async () => {
      setShowLoading(true);
      const result = await getDadosCadastroBoletoDigital();
      if (result !== null) {
        setId(result.idCadastro);
        formik.setFieldValue("email1", result.email1);
        formik.setFieldValue("email2", result.email2);
        formik.setFieldValue("email3", result.email3);
        formik.setFieldValue("tel", addPhoneMask(result.tel, "tel"));
        setTel(formik.values.tel);
        setEmail1(formik.values.email1);
        setEmail2(formik.values.email2);
        setEmail3(formik.values.email3);
      }
    };
    getTicket();
    getPermissao();
  }, []);

  const formik = useFormik({
    initialValues: { tel, email1, email2, email3 },
    validationSchema: TicketRegistrationValidation,
    onSubmit: (values) => {
      handleRegistration(
        values.tel,
        values.email1,
        values.email2,
        values.email3
      );
    },
    validateOnChange: false,
  });

  useEffect(() => {
    setTel(formik.values.tel);
    setEmail1(formik.values.email1);
    setEmail2(formik.values.email2);
    setEmail3(formik.values.email3);
  }, [
    formik.values.tel,
    formik.values.email1,
    formik.values.email2,
    formik.values.email3,
  ]);

  const getPermissao = async () => {
    setShowLoading(true);
    var response = await getPermissaoCadastroBoleto();

    if (response?.status !== 200) {
      setmodalFeedback({
        icon: "error",
        title: "Ocorreu um erro",
        subTitle: response?.data.mensagem
          ? response?.data.mensagem
          : "Erro ao buscar permissão.",
        textButton: "Fechar",
        action: () => {
          setmodalFeedback(null);
          navigate("/home");
        },
      });
      setShowLoading(false);
      return;
    }

    if (!response.data.isPermissao) {
      setPermission(false);

      const listaInfo = response?.data?.listaInfo;
      if (listaInfo.length) {
        const msg = listaInfo.map(
          (info: { mensagem: string }) => info.mensagem
        )[0];
        if (msg) setErrorMessage(msg);
      }
    }
    setShowLoading(false);
  };

  const handleRegistration = async (
    tel: string,
    email1: string,
    email2: string,
    email3: string
  ) => {
    setShowLoading(true);
    const response = await cadastrarBoletoDigital(
      id,
      tel,
      email1,
      email2,
      email3
    );
    if (response?.status !== 200) {
      setmodalFeedback({
        icon: "error",
        title: "Ocorreu um erro",
        subTitle: response?.data.mensagem
          ? response?.data.mensagem
          : "Erro ao salvar E-mail(s).",
        textButton: "Fechar",
        action: () => setmodalFeedback(null),
      });
      setShowLoading(false);
      return;
    } else {
      setId(response.data?.idCadastro);
      setmodalFeedback({
        icon: "success",
        title: "E-mails cadastrados",
        subTitle:
          "Cadastro para recebimento do boleto digital realizado com sucesso!",
        textButton: "Fechar",
        action: () => setmodalFeedback(null),
      });
      setShowLoading(false);
      return;
    }
  };

  function addPhoneMask(input: string, field: string) {
    const cleanInput = input.replace(/\D/g, "");
    let formattedNumber;
    if (input.length <= 10) {
      formattedNumber = cleanInput.replace(
        /(\d{2})(\d{4})(\d{4})/,
        "($1) $2-$3"
      );
    } else {
      formattedNumber = cleanInput.replace(
        /(\d{2})(\d{5})(\d{4})/,
        "($1) $2-$3"
      );
    }
    return formattedNumber;
  }

  const handleDelete = (deleted: string) => {
    setModalAction({
      title: "Excluir e-mail",
      subTitle: "Tem certeza que deseja excluir o e-mail?",
      textOutlinedButton: "Cancelar",
      textContainedButton: "Excluir",
      handleContainedButton: () => onDelete(deleted),
      handleOutlinedButton: () => handleCloseModalAction(),
      handleShowModal: () => handleCloseModalAction(),
      icon: "warning",
    });
  };

  const handleCancelModal = () => {
    setModalAction({
      title: "Boleto digital",
      subTitle:
        "Tem certeza que quer parar o envio do boleto digital?  Você voltará a receber o boleto no endereço de correspondência cadastrado.",
      textOutlinedButton: "Cancelar",
      textContainedButton: "Parar envio",
      handleContainedButton: () => handleCancel(),
      handleOutlinedButton: () => handleCloseModalAction(),
      handleShowModal: () => handleCloseModalAction(),
      icon: "warning",
    });
  };

  const handleCloseModalAction = () => {
    setModalAction(null);
  };

  const handleCancel = async () => {
    setShowLoading(true);
    var response = await cancelarBoletoDigital(id);
    if (response?.status !== 200) {
      setmodalFeedback({
        icon: "error",
        title: "Ocorreu um erro",
        subTitle: response?.data.mensagem
          ? response?.data.mensagem
          : "Erro ao cancelar recebimento de boleto por e-mail.",
        textButton: "Fechar",
        action: () => setmodalFeedback(null),
      });
      handleCloseModalAction();
      setShowLoading(false);
      return;
    } else {
      setmodalFeedback({
        icon: "success",
        title: "Boleto digital cancelado",
        subTitle: "O recebimento de boleto por e-mail foi cancelado.",
        textButton: "Fechar",
        action: () => {
          window.location.reload();
          setmodalFeedback(null);
        },
      });
      handleCloseModalAction();
      setShowLoading(false);
      return;
    }
  };

  const onDelete = (email: string) => {
    handleCloseModalAction();
    switch (email) {
      case "email1":
        formik.setFieldValue("email1", "");
        break;
      case "email2":
        formik.setFieldValue("email2", "");
        break;
      case "email3":
        formik.setFieldValue("email3", "");
        break;
      default:
        break;
    }
  };

  const handleChangeFieldValue = (field: string, value: string) => {
    formik.setFieldValue(field, value);
  };

  return (
    <div className="ticket-registration-holder">
      <LoadingApp showLoading={showLoading} />
      <PageTitle text="Boleto digital" />
      <h2
        className="ticket-registration-subtitle"
        style={accessibility.textStyleAccessibility}
      >
        Cadastre-se e receba o boleto todo mês no seu e-mail
      </h2>

      <div
        className="ticket-registration-instructions-holder"
        style={{
          ...accessibility.contrastStyle,
          ...accessibility.contrastBorderAccessibility,
        }}
      >
        <p
          className="ticket-registration-instructions-introduction"
          style={accessibility.textStyleAccessibility}
        >
            Ao cadastrar seu e-mail, você declara estar ciente e de acordo com a mudança 
            no envio do boleto e do demonstrativo do seu plano de saúde, que agora serão 
            disponibilizados exclusivamente por e-mail. Para garantir o recebimento desses 
            documentos, é essencial manter o(s) endereço(s) de e-mail atualizado(s).
        </p>
        <p
          className="ticket-registration-instructions-introduction"
          style={accessibility.textStyleAccessibility}
        >
            A partir do próximo faturamento, os boletos serão enviados exclusivamente para o(s) 
            e-mail(s) informado(s), substituindo o envio impresso.
        </p>
        <p
          className="ticket-registration-instructions-introduction"
          style={accessibility.textStyleAccessibility}
        >
            Parabéns por escolher uma opção mais prática e sustentável, contribuindo 
            para a preservação do meio ambiente ao reduzir o uso de papel.
        </p>
      </div>
      {!showLoading && !permission ? (
        <div>
          <Typography style={accessibility.textStyleAccessibility}>
            {errorMessage}
          </Typography>
        </div>
      ) : (
        <>
          <h1
            className="ticket-registration-instructions-title"
            style={accessibility.textStyleAccessibility}
          >
            Preencha os dados abaixo para receber mensalmente o boleto e o
            demonstrativo de pagamento em seu e-mail
          </h1>
          <form onSubmit={formik.handleSubmit} noValidate>
            <div className="ticket-registration-fields-holder">
              <div className="ticket-registration-tel">
                <Typography
                  style={accessibility.textStyleAccessibility}
                  sx={sxLabel}
                >
                  Telefone
                </Typography>
                <label htmlFor="telefone" aria-label="telefone" />
                <OutlinedInput
                  id="telefone"
                  fullWidth
                  type={"tel"}
                  value={formik.values.tel}
                  aria-describedby={formik.errors.tel ? "telefone-error" : undefined}
                  onChange={(event) =>
                    handleChangeFieldValue(
                      "tel",
                      cellphoneMask(event.target.value)
                    )
                  }
                  name="tel"
                  error={!!formik.errors.tel}
                  maxRows={1}
                  inputProps={{ maxLength: 15 }}
                  sx={sxInput}
                  style={{
                    ...accessibility.contrastStyle,
                    ...accessibility.textStyleAccessibility,
                  }}
                />
                {formik.errors.tel && (
                  <Typography sx={sxError} id="telefone-error">
                    {formik.errors.tel}
                  </Typography>
                )}
              </div>
              <div className="ticket-registration-email">
                <div className="ticket-registration-field">
                  <Typography
                    style={accessibility.textStyleAccessibility}
                    sx={sxLabel}
                  >
                    E-mail 1
                  </Typography>
                  <label htmlFor="e-mail1" aria-label="e-mail 1" />
                  <OutlinedInput
                    id="e-mail1"
                    fullWidth
                    type={"email"}
                    value={formik.values.email1}
                    aria-describedby={formik.errors.email1 ? "email1-error" : undefined}
                    onChange={(event) =>
                      handleChangeFieldValue("email1", event.target.value)
                    }
                    name="email1"
                    error={!!formik.errors.email1}
                    maxRows={1}
                    inputProps={{ maxLength: 100 }}
                    sx={sxInput}
                    style={{
                      ...accessibility.contrastStyle,
                      ...accessibility.textStyleAccessibility,
                    }}
                  />
                  {formik.errors.email1 && (
                    <Typography sx={sxError} id="email1-error">
                      {formik.errors.email1}
                    </Typography>
                  )}
                </div>
                <div className="flex-col justify-center">
                  <button
                    className="ticket-registration-email-trash"
                    disabled={formik.values.email1 === ""}
                    type="button"
                    tabIndex={0}
                    onClick={() => {
                      handleDelete("email1");
                    }}
                    aria-label="Excluir e-mail"
                  >
                    <TrashIcon />
                  </button>
                </div>
              </div>
              <div className="ticket-registration-email">
                <div className="ticket-registration-field">
                  <Typography
                    style={accessibility.textStyleAccessibility}
                    sx={sxLabel}
                  >
                    E-mail 2
                  </Typography>
                  <label htmlFor="e-mail2" aria-label="e-mail 2" />
                  <OutlinedInput
                    id="e-mail2"
                    fullWidth
                    type={"email"}
                    value={formik.values.email2}
                    aria-describedby={formik.errors.email2 ? "email2-error" : undefined}
                    onChange={(event) =>
                      handleChangeFieldValue("email2", event.target.value)
                    }
                    name="email2"
                    error={!!formik.errors.email2}
                    maxRows={1}
                    inputProps={{ maxLength: 100 }}
                    sx={sxInput}
                    style={{
                      ...accessibility.contrastStyle,
                      ...accessibility.textStyleAccessibility,
                    }}
                  />
                  {formik.errors.email2 && (
                    <Typography sx={sxError} id="email2-error">
                      {formik.errors.email2}
                    </Typography>
                  )}
                </div>
                <div className="flex-col justify-center">
                  <button
                    className="ticket-registration-email-trash"
                    disabled={formik.values.email2 === ""}
                    type="button"
                    tabIndex={0}
                    aria-label="Excluir e-mail"
                    onClick={() => {
                      handleDelete("email2");
                    }}
                  >
                    <TrashIcon />
                  </button>
                </div>
              </div>
              <div className="ticket-registration-email">
                <div className="ticket-registration-field">
                  <Typography
                    style={accessibility.textStyleAccessibility}
                    sx={sxLabel}
                  >
                    E-mail 3
                  </Typography>
                  <label htmlFor="e-mail3" aria-label="e-mail 3" />
                  <OutlinedInput
                    id="e-mail3"
                    fullWidth
                    type={"email"}
                    value={formik.values.email3}
                    aria-describedby={formik.errors.email3 ? "email3-error" : undefined}
                    onChange={(event) =>
                      handleChangeFieldValue("email3", event.target.value)
                    }
                    name="email3"
                    error={!!formik.errors.email3}
                    maxRows={1}
                    inputProps={{ maxLength: 100 }}
                    sx={sxInput}
                    style={{
                      ...accessibility.contrastStyle,
                      ...accessibility.textStyleAccessibility,
                    }}
                  />
                  {formik.errors.email3 && (
                    <Typography sx={sxError} id="email3-error">
                      {formik.errors.email3}
                    </Typography>
                  )}
                </div>
                <div className="flex-col justify-center">
                  <button
                    className="ticket-registration-email-trash"
                    disabled={formik.values.email3 === ""}
                    type="button"
                    onClick={() => {
                      handleDelete("email3");
                    }}
                    aria-label="Excluir e-mail"
                  >
                    <TrashIcon />
                  </button>
                </div>
              </div>
              <div className="ticket-registration-submit">
                <Button
                  variant="contained"
                  type="submit"
                  style={accessibility.textStyleAccessibility}
                  sx={sxButton}
                  disabled={
                    (email1 === "" && email2 === "" && email3 === "") || !tel
                  }
                  fullWidth
                >
                  {id ? "Atualizar" : "Cadastrar"}
                </Button>
              </div>
              <div className="cancel-ticket-registration-holder">
                <h1
                  style={accessibility.textStyleAccessibility}
                  className="ticket-registration-instructions-title"
                >
                  Não deseja mais receber o boleto no seu e-mail?
                </h1>
                <button
                  disabled={!id}
                  className="cancel-ticket-registration"
                  type="button"
                  onClick={handleCancelModal}
                >
                  <u style={accessibility.textStyleAccessibility}>
                    Cancelar boleto digital
                  </u>
                </button>
              </div>
            </div>
          </form>
        </>
      )}
      <ModalAction
        showModal={!!modalAction}
        handleShowModal={modalAction?.handleShowModal}
        textOutlinedButton={modalAction?.textOutlinedButton || ""}
        textContainedButton={modalAction?.textContainedButton || ""}
        title={modalAction?.title || ""}
        subTitle={modalAction?.subTitle || ""}
        handleOutlinedButton={modalAction?.handleOutlinedButton}
        handleContainedButton={modalAction?.handleContainedButton}
        icon="warning"
      />
      <ModalFeedBack
        showModal={modalFeedback ? true : false}
        icon={modalFeedback?.icon as "success" | "error"}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        handleShowModal={modalFeedback?.action}
        showButtonModal
        handleButtonModal={modalFeedback?.action}
      />
    </div>
  );
}

export default CadastrarBoleto;
